export enum DOCS_LINKS {
  USERS = 'https://docs.switch.org.za/mdms/users',
  TARIFFS = 'https://docs.switch.org.za/mdms/tariffs',
  BILLING_RUNS = 'https://docs.switch.org.za/mdms/billing',
  ACCOUNTS = 'https://docs.switch.org.za/mdms/accounts',
  INVOICES = 'https://docs.switch.org.za/mdms/invoices',
  METERS = 'https://docs.switch.org.za/mdms/meters/manual-data',
  ZONES = 'https://docs.switch.org.za/mdms/zones',
  PROFIT_SHARE = 'https://docs.switch.org.za/mdms/tariffs#the-charge-types',
  APPLICATIONS = 'https://docs.switch.org.za/mdms/applications',
  PROVIDERS = 'https://docs.switch.org.za/mdms',
  SERVICE_CHARGE = 'https://docs.switch.org.za/mdms/billing#the-prepaid-flow',
  DEVICE_REPLACEMENT = 'https://docs.switch.org.za/mdms/meters/device-replacement',
}

export enum MOBILE_APP_LINKS {
  ANDROID = 'https://play.google.com/store/apps/details?id=za.org.switchenergy.mobile',
  IOS = 'https://apps.apple.com/us/app/switch-energy/id1629686733',
}
